import { Spacer } from '@sparemin/blockhead';
import useMobileBreakpoint from 'hooks/useMobileBreakpoint';
import React from 'react';
import { ModalName } from 'state/modals';
import EmailIcon from '../EmailIcon';

import * as S from './styles';

interface IconModalProps {
  modalName: ModalName;
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
}

const IconModal: React.FC<IconModalProps> = ({
  modalName,
  title,
  subtitle,
  children,
  icon = <EmailIcon />,
}) => {
  const isMobile = useMobileBreakpoint('lg');
  return (
    <S.Dialog name={modalName} fullScreen={isMobile}>
      <S.Card
        header={<S.CardHeader icon={icon} title={title} subtitle={subtitle} />}
        footer={<S.CardFooter />}
      >
        <S.CardContents>
          <Spacer orientation="vertical" space="16px" align="center">
            {children}
          </Spacer>
        </S.CardContents>
      </S.Card>
    </S.Dialog>
  );
};
export default IconModal;
